export const ComponentRegistry = [
    'component/bulk-action-bar/bulk-action-bar',
    'component/button/back/back',
    'component/button/cancel/cancel',
    'component/button/dropdown-button/dropdown-button',
    'component/button/ellipsis-dropdown',
    'component/button/splitButton/split-button',
    'component/callout/details',
    'component/combobox/department',
    'component/combobox/icon-select',
    'component/combobox/ruleset',
    'component/combobox/syncfield',
    'component/combobox/system-role',
    'component/combobox/v2',
    'component/component/proxy',
    'component/copy-to-clipboard/button',
    'component/customer/comments/details',
    'component/customer/comments/edit',
    'component/customer/dialog/delete.customer',
    'component/customer/dialog/restore-first-time-passwords',
    'component/customer/general/create',
    'component/customer/general/details',
    'component/customer/general/edit',
    'component/customer/general/smsfield',
    'component/customer/sso/details',
    'component/customer/sso/mapping',
    'component/customer/sso/parsed',
    'component/customer/sso/security',
    'component/department/hierarchy',
    'component/legal-unit/hierarchy',
    'component/dialog/component/basic',
    'component/dialog/confirm/basic',
    'component/dialog/manager',
    'component/dropdown/menu',
    'component/dynamic-variable/dialog/builder',
    'component/dynamic-variable/dialog/context',
    'component/dynamic-variable/dialog/expression',
    'component/dynamic-variable/dialog/pick/message-template',
    'component/dynamic-variable/dialog/pick/syncfield',
    'component/dynamic-variable/dialog/preview',
    'component/dynamic-variable/highlight',
    'component/dynamic-variable/highlightmanager',
    'component/dynamic-variable/list',
    'component/dynamic-variable/listmanager',
    'component/dynamic-variable/text-area',
    'component/dynamic-variable/text-area-rich',
    'component/dynamic-variable/text-input',
    'component/export-template/copy-wizard/main',
    'component/export-template/create',
    'component/export-template/details',
    'component/export-template/dialog/delete',
    'component/export-template/edit',
    'component/export-template/export/mapping',
    'component/export-template/export/syncstep',
    'component/export-template/mapping/expression',
    'component/export-template/mapping/mutable/dialog/exchange',
    'component/export-template/mapping/mutable/export',
    'component/export-template/mapping/mutable/import',
    'component/export-template/mapping/read/export',
    'component/export-template/mapping/read/import',
    'component/export-template/parentpath/mutable',
    'component/export-template/parentpath/read',
    'component/export-template/search',
    'component/export-template/visma/mutable',
    'component/export-template/visma/read',
    'component/fa/filter',
    'component/fa/icon',
    'component/form/instance/contributors-list',
    'component/form/instance/search',
    'component/form/template/available/search',
    'component/form/template/create/details',
    'component/form/template/edit/details',
    'component/form/template/mutable/details',
    'component/form/template/mutable/page',
    'component/form/template/properties/mutable',
    'component/form/template/properties/preview',
    'component/form/template/properties/type/areabox',
    'component/form/template/properties/type/button',
    'component/form/template/properties/type/checkbox',
    'component/form/template/properties/type/datebox',
    'component/form/template/properties/type/default',
    'component/form/template/properties/type/function',
    'component/form/template/properties/type/inputbox',
    'component/form/template/properties/type/listbox',
    'component/form/template/properties/type/parameter/boolean',
    'component/form/template/properties/type/parameter/date',
    'component/form/template/properties/type/parameter/syncfield-id',
    'component/form/template/properties/type/parameter/text',
    'component/form/template/properties/type/parameter/textarea',
    'component/form/template/properties/type/radio',
    'component/form/template/read/details',
    'component/form/template/read/dialog/open',
    'component/form/template/read/dialog/openv2',
    'component/form/template/read/versionredirect',
    'component/form/template/search',
    'component/form/view/details',
    'component/form/view/part/areabox',
    'component/form/view/part/button',
    'component/form/view/part/checkbox',
    'component/form/view/part/datebox',
    'component/form/view/part/inputbox',
    'component/form/view/part/listbox',
    'component/form/view/part/radio',
    'component/form/view/view-v2',
    'component/group/create-wizard',
    'component/group/edit-wizard',
    'component/group/members/details',
    'component/group/members/dialog/add-members',
    'component/group/members/dialog/add-members-search',
    'component/group/search',
    'component/group/used-in',
    'component/heading/sub-accordion',
    'component/http/http',
    'component/import/details',
    'component/import/dialog/send-end-report',
    'component/import/search',
    'component/import/test',
    'component/layout/details',
    'component/layout/header/comments',
    'component/layout/header/details',
    'component/layout/header/language-picker',
    'component/layout/header/organization-picker',
    'component/layout/left/details',
    'component/layout/left/skeleton',
    'component/layout/right/details',
    'component/layout/right/hubspot-chat',
    'component/layout/right/skeleton',
    'component/log/audit/search',
    'component/log/error/search',
    'component/log/security/search',
    'component/login/company-select',
    'component/login/dialog/multi-token',
    'component/login/form',
    'component/message/error-object',
    'component/message/inline-error',
    'component/message/page-message',
    'component/message/simple-message',
    'component/messages/create',
    'component/messages/createehub',
    'component/messages/copy-wizard/main',
    'component/messages/deleteehub',
    'component/messages/details',
    'component/messages/dialog/delete',
    'component/messages/dialog/multi-activate',
    'component/messages/dialog/multi-deactivate',
    'component/messages/dialog/multi-delete',
    'component/messages/dialog/send-messages-by-message-flows',
    'component/messages/edit',
    'component/messages/editehub',
    'component/messages/log',
    'component/messages/message-type',
    'component/messages/message-type-static',
    'component/messages/preview',
    'component/messages/read/info',
    'component/messages/recipients',
    'component/messages/recipients/object',
    'component/messages/recipients/objects',
    'component/messages/search',
    'component/messages/search-select',
    'component/messages/send/wizard',
    'component/meta/multi',
    'component/modal/component',
    'component/modal/dialog',
    'component/object/anchor',
    'component/object/create',
    'component/object/dialog/delete',
    'component/object/dialog/export.anchors.csv',
    'component/object/dialog/export.csv',
    'component/object/dialog/export.members.csv',
    'component/object/dialog/invalid.anchor',
    'component/object/dialog/manual.syncfield.edit',
    'component/object/dialog/objectfield.edit',
    'component/object/dialog/pick',
    'component/object/dialog/purge',
    'component/object/dialog/recreate',
    'component/object/dialog/recreate.history',
    'component/object/dialog/remove.manual.permission',
    'component/object/dialog/reset.password',
    'component/object/dialog/selectobjects',
    'component/object/dialog/syncfield.edit',
    'component/object/edit',
    'component/object/history/import',
    'component/object/history/import-nav-bar-left',
    'component/object/history/instance',
    'component/object/linked',
    'component/object/raw',
    'component/object/search',
    'component/object/selected-list',
    'component/object/syncfield/boolean',
    'component/object/syncfield/edit',
    'component/object/upload/objects',
    'component/override/override-details',
    'component/override/override-status',
    'component/override/permission',
    'component/override/syncfield',
    'component/password/forgot/details',
    'component/password/forgot/method-bankidse',
    'component/password/forgot/method-idporten',
    'component/password/forgot/method-sms',
    'component/password/forgot/method-teliafi',
    'component/password/progress',
    'component/password/tap/details',
    'component/password/v2/details',
    'component/password/v2/form',
    'component/password/v2/input',
    'component/password/v2/suggestions',
    'component/permission/create',
    'component/permission/list-user-item',
    'component/permission/system-permission/cell/expirydate',
    'component/permission/system-permission/cell/managerof',
    'component/permission/system-permission/cell/override',
    'component/permission/system-permission/cell/role',
    'component/permission/system-permission/immutable',
    'component/permission/system-permission/mutable',
    'component/permission/wizard',
    'component/permission/wizard/dialog/paste',
    'component/picker/date',
    'component/picker/user',
    'component/picker/user-any',
    'component/privacy/organization',
    'component/privacy/policy',
    'component/privacy/policy-page',
    'component/report/details',

    'component/report/lastsync',
    'component/report/status',
    'component/route/button/heading',
    'component/route/button/page',
    'component/route/buttons/page',
    'component/route/destination',
    'component/route/details/basic',
    'component/route/heading',
    'component/route/heading-label',
    'component/route/redirect',
    'component/ruleset/derived/details',
    'component/ruleset/derived/group',
    'component/ruleset/derived/item',
    'component/ruleset/derived/showmore',
    'component/ruleset/copy-wizard/main',
    'component/ruleset/copy-wizard/sub/stepper-host',
    'component/ruleset/copy-wizard/sub/wizard-heading',
    'component/ruleset/copy-wizard/sub/wizard-nav-footer',
    'component/ruleset/copy-wizard/sub/target-org-combobox',
    'component/ruleset/dialog/delete',
    'component/ruleset/dialog/multi-delete',
    'component/ruleset/mutable/create',
    'component/ruleset/mutable/edit',
    'component/ruleset/mutable/rule/argument',
    'component/ruleset/mutable/rule/argument/array',
    'component/ruleset/mutable/rule/argument/buttons',
    'component/ruleset/mutable/rule/argument/datetime',
    'component/ruleset/mutable/rule/argument/entrytype',
    'component/ruleset/mutable/rule/attribute',
    'component/ruleset/mutable/rule/condition',
    'component/ruleset/mutable/rule/dialog/pick-object',
    'component/ruleset/mutable/rule/dialog/pick-object-attribute',
    'component/ruleset/mutable/rules',
    'component/ruleset/pick',
    'component/ruleset/preview/department',
    'component/ruleset/preview/diff',
    'component/ruleset/preview/formdata',
    'component/ruleset/preview/clientcredential',
    'component/ruleset/preview/group',
    'component/ruleset/preview/user',
    'component/ruleset/read/details',
    'component/ruleset/read/info',
    'component/ruleset/read/rules',
    'component/ruleset/search',
    'component/ruleset/search-select',
    'component/ruleset/used-in/details',
    'component/ruleset/variable/crud',
    'component/ruleset/wizard/comp/add-departments',
    'component/ruleset/wizard/manager',
    'component/ruleset/wizard/rule',
    'component/ruleset/wizard/step-1',
    'component/ruleset/wizard/step-2',
    'component/search/inline-rename',
    'component/search/navigation',
    'component/search/show-all',
    'component/search/td-checkbox',
    'component/search/th-checkbox',
    'component/select/base',
    'component/select/syncfield',
    'component/settings/details',
    'component/settings/sidepanel',
    'component/settings/syncfields',
    'component/sitemap/sitemap',
    'component/snackbar-dialog/snackbar-dialog',
    'component/sortable/button',
    'component/sortable/sortable-table',
    'component/sortable/sortable-table-heading',
    'component/sync/status-v2/btn-header',
    'component/sync/status-v2/cards/importfilter/details',
    'component/sync/status-v2/cards/notification/details',
    'component/sync/status-v2/cards/status/details',
    'component/sync/status-v2/checkbox/checkbox',
    'component/sync/status-v2/details',
    'component/sync/credentials/details',
    'component/sync/credentials/dialog/delete',
    'component/sync/export-queue/details',
    'component/sync/integration-tests/details',
    'component/sync/status-v2/input',
    'component/sync/status-v2/synccycle/details',
    'component/sync/status-v2/synccycle/export-filter/details',
    'component/sync/status-v2/synccycle/export-filter/edit',
    'component/sync/status-v2/synccycle/parameters/details',
    'component/sync/status-v2/synccycle/parameters/edit',
    'component/system/application',
    'component/system/execute-syncstep',
    'component/system/importp360roles',
    'component/system/testexportp360',
    'component/systemaccess/create',
    'component/systemaccess/details',
    'component/systemaccess/dialog/groups-to-permissions',
    'component/systemaccess/dialog/move-roles',
    'component/systemaccess/dialog/purge-collection',
    'component/systemaccess/dialog/purge-permission',
    'component/systemaccess/dialog/purge-permissions',
    'component/systemaccess/edit',
    'component/systemaccess/mutable-systemaccessinfo',
    'component/systemaccess/read/info',
    'component/systemaccess/roles/instance/crud-availableto-ruleset',
    'component/systemaccess/roles/instance/crud-member-ruleset',
    'component/systemaccess/roles/instance/details',
    'component/systemaccess/roles/instance/mutable',
    'component/systemaccess/roles/instance/pick-groups',
    'component/systemaccess/roles/instance/pick-groups-search',
    'component/systemaccess/roles/search/details',
    'component/systemaccess/search',
    'component/systemaccess/wizard/generate-rs-and-mf/main',
    'component/systemaccess/wizard/generate-rs-and-mf/messageflow',
    'component/systemaccess/wizard/generate-rs-and-mf/recipients',
    'component/systemaccess/wizard/generate-rs-and-mf/ruleset',
    'component/systemfields/context',
    'component/systemfields/copy/all',
    'component/systemfields/details',
    'component/systemfields/list/details',
    'component/systemfields/list/group',
    'component/systemfields/list/item',
    'component/systemfields/list/table',
    'component/systemfields/wizard/export',
    'component/systemfields/wizard/import',
    'component/page-shell/details',
    'component/page-shell/tab-panels',
    'component/table/basic',
    'component/table/selected',
    'component/toggle-eye/toggle-eye',
    'component/toggle/attribute-name-radio',
    'component/toggle/boxy',
    'component/toggle/checkbox',
    'component/toggle/radio',
    'component/toggle/switch',
    'component/tooltip/tooltip',
    'component/user/export-queue',
    'component/user/membership-v2/details',
    'component/user/membership-v2/dialog/add-groups',
    'component/user/membership-v2/dialog/add-groups-search',
    'component/user/messages/buttons',
    'component/user/messages/details',
    'component/user/permissions-v2/details',
    'component/user/search',
    'component/user/search.by.department',
    'component/user/select',
    'component/user/syncfields/employment',
    'component/user/syncfields/enrollment',
    'component/user/syncfields/personal',
    'component/user/syncfields/positions',
    'component/user/syncfields/positions-page',
    'component/user/syncfields/view-list',
    'component/user/syncfields/view-value',
    'component/user/wizard/create',
    'component/user/wizard/edit',
    'component/user/wizard/personalia',
    'component/user/wizard/position',
    'component/user/wizard/summary',
    'component/variable/companysyncstep',
    'component/variable/department',
    'component/variable/department/from-syncfield',
    'component/variable/employee-status-code',
    'component/variable/exporttemplate',
    'component/variable/form-template',
    'component/variable/messagetemplate',
    'component/variable/object-by-any',
    'component/variable/object-by-id',
    'component/variable/object-type-name',
    'component/variable/organization',
    'component/variable/ruleset',
    'component/variable/syncfield-name',
    'component/variable/syncstep',
    'component/variable/syncstep-or-companysyncstep',
    'component/variable/system-by-id',
    'component/variable/system-role-by-id',
    'component/variable/user/id',
    'component/heading/heading-v2',
// END OF COMPONENTS LIST
] as const;

export type TComponentName = typeof ComponentRegistry[number];
